import * as React from "react";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Container from "@mui/material/Container";
import Typography from "../components/Typography";
import { SocialLinks } from "../components/SocialLinks";

function Copyright() {
  return (
    <React.Fragment>
      {"© "}
      <Link color="inherit" href="https://emilybarlowwritesthings.com/">
        emilybarlowwritesthings.com
      </Link>{" "}
      {new Date().getFullYear()}
    </React.Fragment>
  );
}

export default function AppFooter() {
  return (
    <Typography component="footer" sx={{ display: "flex", bgcolor: "secondary.light" }}>
      <Container sx={{ my: 8, display: "flex" }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={8}>
            <SocialLinks location="footer" showLabels />
          </Grid>
          <Grid item xs={12} md={4} sx={{ textAlign: { xs: "left", md: "right" } }}>
            <Copyright />
          </Grid>
        </Grid>
      </Container>
    </Typography>
  );
}
